import React, { FunctionComponent, SVGProps } from 'react'

export const IconPhone: FunctionComponent<SVGProps<SVGSVGElement>> = (
  props
) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      stroke="#0062CA"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.4541 11.2802V13.2802C14.4548 13.4659 14.4168 13.6497 14.3424 13.8198C14.268 13.9899 14.1589 14.1426 14.0221 14.2681C13.8853 14.3937 13.7238 14.4892 13.5479 14.5487C13.372 14.6082 13.1856 14.6303 13.0007 14.6136C10.9493 14.3907 8.97872 13.6897 7.24739 12.5669C5.63661 11.5433 4.27095 10.1777 3.24739 8.56689C2.12071 6.8277 1.41955 4.84756 1.20072 2.78689C1.18406 2.60254 1.20597 2.41673 1.26506 2.24131C1.32414 2.06589 1.4191 1.90469 1.5439 1.76797C1.6687 1.63126 1.82059 1.52203 1.98992 1.44724C2.15924 1.37245 2.34228 1.33374 2.52739 1.33356H4.52739C4.85093 1.33038 5.16459 1.44495 5.4099 1.65592C5.65521 1.86689 5.81544 2.15986 5.86072 2.48023C5.94514 3.12027 6.10169 3.74871 6.32739 4.35356C6.41709 4.59218 6.4365 4.8515 6.38333 5.10081C6.33016 5.35012 6.20663 5.57897 6.02739 5.76023L5.18072 6.60689C6.12976 8.27592 7.51169 9.65786 9.18072 10.6069L10.0274 9.76023C10.2086 9.58099 10.4375 9.45746 10.6868 9.40429C10.9361 9.35112 11.1954 9.37053 11.4341 9.46023C12.0389 9.68593 12.6673 9.84248 13.3074 9.92689C13.6312 9.97258 13.927 10.1357 14.1384 10.3852C14.3498 10.6348 14.4622 10.9533 14.4541 11.2802Z"
        fill="none"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
